// Vendor
import React, { Component } from 'react';
// import { Link } from 'react-router-dom'
import Link from 'next/link';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
// import difference from 'lodash/difference';
// import ReactHtmlParser from 'react-html-parser';
import cn from 'classnames';
// Components
import Button from '../../components/Button';
import Radio from '../../components/Radio';
import Select from '../../components/Select';
import { Form, Field, FormSpy } from 'react-final-form';
// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

class FeedFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilter: false,
      lastChange: {
        key: undefined,
        value: undefined,
      },
      values: {},
    };
  }

  handleSubmit = () => {};

  formChange = ({ values }) => {
    if (!isEqual(values, this.oldValues)) {
      if (typeof values === typeof this.oldValues) {
        const key = getObjectDiff(values, this.oldValues)[0];
        const value = values[key] || this.oldValues[key];
        this.setState({
          lastChange: { key, value },
          values,
        });
      }

      function getObjectDiff(obj1, obj2) {
        const diff = Object.keys(obj1).reduce((result, key) => {
          if (!obj2.hasOwnProperty(key)) {
            result.push(key);
          } else if (isEqual(obj1[key], obj2[key])) {
            const resultKeyIndex = result.indexOf(key);
            result.splice(resultKeyIndex, 1);
          }
          return result;
        }, Object.keys(obj2));

        return diff;
      }

      this.props.changeFilter(values);
    }
    this.oldValues = values;
  };

  openFilter = () => {
    this.setState({
      showFilter: true,
    });
  };

  closeFilter = e => {
    e.preventDefault();
    this.setState({
      showFilter: false,
    });
  };

  render() {
    const { showFilter, lastChange, values } = this.state;
    const { className, fields, isEntriesLoading } = this.props;

    const isFields = !!(fields && Object.keys(fields).length);
    const classFilter = cn({
      FeedFilter__content: true,
      FeedFilter__filter: true,
      FeedFilter__filter_opened: showFilter,
    });

    const isNeedAudience = !(values.customer_id > 2);

    return (
      <section className={cn('FeedFilter', className)}>
        {isFields && (
          <div className={classFilter}>
            <Form
              onSubmit={this.handleSubmit}
              render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form className="FeedFilter__form">
                  <FormSpy onChange={this.formChange} />

                  <div className="FeedFilter__header">
                    <div className="FeedFilter__close" onClick={this.closeFilter} />
                    Фильтр
                  </div>

                  <div className="FeedFilter__body">
                    <div className="FeedFilter__sections">
                      <div className="FeedFilter__section">
                        <div className="FeedFilter__label">Аудитория</div>
                        <div className="FeedFilter__field">
                          {fields.customer &&
                            fields.customer.map((item, index) => {
                              return (
                                <Field
                                  key={item.id}
                                  name="customer_id"
                                  type="radio"
                                  value={String(item.id)}
                                  render={({ input, meta }) => (
                                    <Radio
                                      {...input}
                                      text={
                                        item.title.charAt(0).toUpperCase() + item.title.substr(1)
                                      }
                                      light
                                      reseteble
                                      checked={values.customer_id == item.id}
                                      loading={
                                        isEntriesLoading &&
                                        lastChange.key === 'customer_id' &&
                                        lastChange.value === String(item.id)
                                      }
                                    />
                                  )}
                                />
                              );
                            })}
                        </div>
                      </div>

                      <div className="FeedFilter__section">
                        <div className="FeedFilter__label">Сегмент бизнеса</div>
                        <div className="FeedFilter__field">
                          {fields.audience &&
                            fields.audience.map((item, index) => {
                              return (
                                <Field
                                  key={item.id}
                                  name="audience_id"
                                  type="radio"
                                  value={String(item.id)}
                                  render={({ input, meta }) => (
                                    <Radio
                                      {...input}
                                      text={item.title}
                                      light
                                      reseteble
                                      disabled={!isNeedAudience}
                                      checked={values.audience_id == item.id}
                                      loading={
                                        isEntriesLoading &&
                                        lastChange.key === 'audience_id' &&
                                        lastChange.value === String(item.id)
                                      }
                                    />
                                  )}
                                />
                              );
                            })}
                        </div>
                      </div>

                      <div className="FeedFilter__section">
                        <div className="FeedFilter__label">Влияние на метрику</div>
                        <div className="FeedFilter__field">
                          <Field
                            name="result"
                            type="radio"
                            value="positive"
                            render={({ input, meta }) => (
                              <Radio
                                {...input}
                                text="Повысило"
                                light
                                reseteble
                                checked={values.result == 'positive'}
                                loading={
                                  isEntriesLoading &&
                                  lastChange.key === 'result' &&
                                  lastChange.value === 'positive'
                                }
                              />
                            )}
                          />
                          <Field
                            name="result"
                            type="radio"
                            value="negative"
                            render={({ input, meta }) => (
                              <Radio
                                {...input}
                                text="Понизило"
                                light
                                reseteble
                                checked={values.result == 'negative'}
                                loading={
                                  isEntriesLoading &&
                                  lastChange.key === 'result' &&
                                  lastChange.value === 'negative'
                                }
                              />
                            )}
                          />
                          <Field
                            name="result"
                            type="radio"
                            value="neutral"
                            render={({ input, meta }) => (
                              <Radio
                                {...input}
                                text="Не&nbsp;повлияло"
                                light
                                reseteble
                                checked={values.result == 'neutral'}
                                loading={
                                  isEntriesLoading &&
                                  lastChange.key === 'result' &&
                                  lastChange.value === 'neutral'
                                }
                              />
                            )}
                          />
                        </div>
                      </div>

                      {false && (
                        <div className="FeedFilter__section">
                          <div className="FeedFilter__label">Контекст [это выпадающий список]</div>
                          <div className="FeedFilter__field">
                            <Select
                              name="context_id"
                              options={fields.context}
                              placeholder="Укажите контекст"
                              wide
                              light
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <Button
                    onClick={this.closeFilter}
                    className="FeedFilter__only-mobile FeedFilter__show-entries"
                    mobilewide
                    big>
                    Показать инсайты
                  </Button>
                </form>
              )}
            />
          </div>
        )}

        {isFields && (
          <div className="FeedFilter__content FeedFilter__mobile">
            <div className="FeedFilter__open-button" onClick={this.openFilter}>
              <div className="FeedFilter__open-icon" />
              Фильтр
            </div>
          </div>
        )}
      </section>
    );
  }
}

FeedFilter.defaultProps = {
  className: '',
};

FeedFilter.propTypes = {
  className: PropTypes.string,
};

export default FeedFilter;



// WEBPACK FOOTER //
// components/FeedFilter/index.js